import React from "react";
import { Button, Dialog } from "@blueprintjs/core";
import ModalRouter from "./ModalRouter";
import { Translate, I18n } from "react-redux-i18n";
import { addProduct, toggleBuyButton, nextPage, removeProduct } from "../../store/b2b_button/creators";
import { showModal, currentPage, getCreatedCircle } from "../../store/b2b_button/selectors";
import { navigate } from "../../store/navigation/operations";
import ReactGA from "react-ga";

import { connect } from "react-redux";
import "./B2BModalFlow.scss";

const modalTitle = (page) => {
  const titles = {
    1: "b2b.use_together",
    2: "b2b.use_together",
    3: "b2b.use_together",
    4: "b2b.share_your_group",
    5: "b2b.mark_your_interest",
  };
  return titles[page];
};

const modalClass = (page) => {
  if (page === 4) {
    return "b2b-share-modal";
  } else {
    return "b2b-modal";
  }
};
const portalClass = (page) => {
  if (page === 4) {
    return "b2b-share-modal-container";
  } else {
    return "b2b-modal-container";
  }
};
class BuyButton extends React.Component {
  showModal = () => {
    ReactGA.event({
      category: "B2B widget",
      action: "Clicked buy button",
    });
    this.props.addProduct(this.props.product);
    this.props.toggleBuyButton(true);
  };
  onClose = () => {
    if (this.props.page === 4) {
      this.props.navigate(`/circle-toolbox/${this.props.circle.guid}`);
      this.props.removeProduct();
    } else if (this.props.page === 5) {
      this.props.removeProduct();
    } else {
      this.props.nextPage(5);
    }
  };

  render() {
    const { show_modal, page } = this.props;
    return (
      <>
        <Button
          onClick={this.showModal}
          text={I18n.t("b2b.buy_with_friends")}
          fill={true}
          intent="primary"
          className="cta primary-outline b2b-cta-modal-trigger"
        />

        <Dialog
          onClose={this.onClose}
          title={<Translate value={modalTitle(page)} dangerousHTML />}
          autoFocus={true}
          canEscapeKeyClose={true}
          canOutsideClickClose={false}
          enforceFocus={true}
          isOpen={show_modal}
          usePortal={true}
          className={modalClass(page)}
          portalClassName={portalClass(page)}>
          <ModalRouter page={page} />
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  show_modal: showModal(state),
  page: currentPage(state),
  circle: getCreatedCircle(state),
});

const mapDispatchToProps = {
  toggleBuyButton,
  addProduct,
  nextPage,
  removeProduct,
  navigate,
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyButton);
